/** English widget embed strings (default language). */

export const en = {
  live: 'LIVE',
  upcoming: 'Upcoming',
  fullTime: 'Full time',
  vs: 'vs',
  noMatches: 'No matches available.',
  noData: 'No data available.',
  goals: 'Goals',
  assists: 'Assists',
  appearances: 'Apps',
  minutes: 'Min',
  played: 'Pl',
  won: 'W',
  drawn: 'D',
  lost: 'L',
  points: 'Pts',
  form: 'Form',
  position: 'Pos',
  player: 'Player',
  team: 'Team',
  coach: 'Coach',
  venue: 'Venue',
  referee: 'Referee',
  attendance: 'Attendance',
  halfTime: 'Half-time',
  overall: 'OVERALL',
  all: 'All',
  home: 'HOME',
  away: 'AWAY',
  teamList: 'Team list',
  teamProfile: 'Team profile',
  playerList: 'Player list',
  playerProfile: 'Player profile',
  status: 'Status',
  matchCoaches: 'Match coaches',
  headCoach: 'Head coach',
  nationality: 'Nationality',
  age: 'Age',
  appointed: 'In role since',
  formation: 'Formation',
  opponent: 'Opponent today',
  touchline: 'Touchline',
  homeVenue: 'Home ground',
  goalsFor: 'GF',
  goalsAgainst: 'GA',
  goalDifference: 'GD',
  squadPlayers: 'players in squad',
  fullSquad: 'Full squad',
  selectTeamSquad: 'Select a team',
  selectTeamSquadHint:
    'Use the Team dropdown above the preview to load every player for that club.',
  noSquadData: 'No squad data for this team in the feed.',
  captain: 'Captain',
  injured: 'Injured',
  rating: 'Rating',
  cards: 'Cards',
};
